"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { Button, Divider } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
export function TaggedServicesCategoryButton(t0) {
  const $ = _c(14);
  const {
    title,
    isActive,
    onClick,
    className,
    depth: t1
  } = t0;
  const depth = t1 === undefined ? 0 : t1;
  const depthClass = depth === 0 ? "!pl-5" : depth === 1 ? "!pl-8" : depth === 2 ? "!pl-11" : "!pl-14";
  const t2 = isActive ? "primary" : "secondary";
  const t3 = depth === 0 ? "!text-h4" : "!text-body";
  let t4;
  if ($[0] !== className || $[1] !== depthClass || $[2] !== t3) {
    t4 = cx("w-full justify-start !pr-5 !py-2.5 text-left", depthClass, t3, className);
    $[0] = className;
    $[1] = depthClass;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== depth) {
    t5 = depth > 0 && <span className="mr-2 text-foreground-secondary" aria-hidden="true">└</span>;
    $[4] = depth;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <span>{title}</span>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onClick || $[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Button variant={t2} onClick={onClick} className={t4}>{t5}{t6}</Button>;
    $[8] = onClick;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
export function TaggedServicesLayout(t0) {
  const $ = _c(8);
  const {
    sidebar,
    children
  } = t0;
  let t1;
  if ($[0] !== sidebar) {
    t1 = <aside className="min-h-0 md:sticky md:top-20 md:max-h-[calc(100vh-2rem)] md:w-[15rem] md:shrink-0 md:overflow-y-auto md:pr-1"><div className="space-y-3">{sidebar}</div></aside>;
    $[0] = sidebar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider className="my-0 md:hidden" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="min-w-0 flex-1 scroll-mt-20">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="flex flex-col gap-4 md:flex-row md:items-start xl:min-w-[60rem]">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}